var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 17C20.5732 17 21.0566 17.2 21.4499 17.6C21.8432 18 22.0366 18.4667 22.0299 19L13.9999 22L6.99989 20V11H8.94989L16.2199 13.69C16.7399 13.8967 16.9999 14.27 16.9999 14.81C16.9999 15.1233 16.8866 15.3967 16.6599 15.63C16.4332 15.8633 16.1466 15.9867 15.7999 16H12.9999L11.2499 15.33L10.9199 16.27L12.9999 17H19.9999ZM15.9999 3.23C16.7066 2.41 17.6066 2 18.6999 2C19.6066 2 20.3732 2.33333 20.9999 3C21.6266 3.66667 21.9599 4.43333 21.9999 5.3C21.9999 5.98667 21.6666 6.80667 20.9999 7.76C20.3332 8.71333 19.6766 9.51 19.0299 10.15C18.3832 10.79 17.3732 11.74 15.9999 13C14.6132 11.74 13.5932 10.79 12.9399 10.15C12.2866 9.51 11.6299 8.71333 10.9699 7.76C10.3099 6.80667 9.98655 5.98667 9.99989 5.3C9.99989 4.39333 10.3232 3.62667 10.9699 3C11.6166 2.37333 12.3966 2.04 13.3099 2C14.3766 2 15.2732 2.41 15.9999 3.23ZM0.983887 11H4.99989V22H0.983887V11Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.b0b511a1.svg";
export { ForwardRef as ReactComponent };